import { Box } from '@mui/material'

import Styles from './style'

export const Wrapper = (props) => {
    const rootSx = {
        ...Styles.root,
        ...props.sx
    }

    return (
        <Box {...props} sx={rootSx}>
            {props.children}
        </Box>
    )
}

export default Wrapper